import { SubpropertyService } from '@modules/subproperty/subproperty-service';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import config from '@/config';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';


export default {
  namespaced: true,

  state: {
    findLoading: false,
    checkExistsloading: false,
    updateLoading: false,
    slug: null,
    existsSlug: false,
    isCheckSuccessSlug: false,
  },

  getters: {
    findLoading: state => state.findLoading,
    updateLoading: state => state.updateLoading,
    checkExistsloading: state => state.checkExistsloading,
    slug: state => state.slug,
    slugUrl: state => `${config.registrationSiteUrl}/${state.slug}`,
    existsSlug: state => state.existsSlug,
    isCheckSuccessSlug: state => state.isCheckSuccessSlug,
  },

  mutations: {
    SLUG_TYPPING(state) {
      state.isCheckSuccessSlug = false;
      state.existsSlug = false;
    },

    SLUG_STARTED(state) {
      state.findLoading = true;
    },

    SLUG_SUCCESS(state, { slug }) {
      state.findLoading = false;
      state.slug = slug;
      state.existsSlug = false;
    },

    SLUG_ERROR(state) {
        state.findLoading = false;
        state.slug = null;
        state.existsSlug = false;
    },

    EXISTS_SLUG_STARTED(state) {
      state.checkExistsloading = true;
    },

    EXISTS_SLUG_SUCCESS(state, { existsSlug }) {
      state.isCheckSuccessSlug = true;
      state.checkExistsloading = false;
      state.existsSlug = existsSlug;
    },

    EXISTS_SLUG_ERROR(state, { existsSlug }) {
        state.checkExistsloading = false;
        state.updateLoading = false;
        state.existsSlug = existsSlug;
    },

    UPDATE_SLUG_STARTED(state) {
      state.updateLoading = true;
    },

    UPDATE_SLUG_SUCCESS(state, { slug }) {
      state.updateLoading = false;
      state.slug = slug;
      state.isCheckSuccessSlug = false;
    },

    UPDATE_SLUG_ERROR(state) {
      state.updateLoading = false;
      state.slug = null;
    },
  },

  actions: {
    doTyping({ commit }) {
      commit('SLUG_TYPPING');
    },

    async doLoadSlug(
      { commit },
      { subpropertyId }
    ) {
      try {
        commit('SLUG_STARTED');
        const slug = await SubpropertyService.slug(subpropertyId);

        commit('SLUG_SUCCESS', { slug });
      } catch (error) {
          commit('SLUG_ERROR');
      }
    },

    async doCheckExistsSlug(
      { commit },
      { slug }
    ) {
      try {
        commit('EXISTS_SLUG_STARTED');
        const existsSlug =  await SubpropertyService.checkExistsSlug(slug);

        if (existsSlug) {
            commit('EXISTS_SLUG_ERROR', { existsSlug });
        } else {
          commit('EXISTS_SLUG_SUCCESS', { existsSlug });
        }
      } catch (error) {
          commit('EXISTS_SLUG_ERROR');
      }
    },

    async doUpdateSlug(
      { commit, rootGetters, dispatch },
      { propertyId, subpropertyId, slug }
    ) {
      try {
        commit('UPDATE_SLUG_STARTED');
        await SubpropertyService.updateSlug(subpropertyId, slug);

        dispatch('subproperty/requirements/doFetch', {
          propertyId,
          subpropertyId,
          userId: rootGetters['auth/currentUser'].id
        }, {
          root: true
        });

        commit('UPDATE_SLUG_SUCCESS', { slug });
        Message.success(i18n('entities.subproperty.customize.update.success'));
        routerAsync().back();
      } catch (error) {
        Errors.handle(error, () => {
          commit('EXISTS_SLUG_ERROR', { existsSlug: true });
        });
      }
    },
  },
};
